import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useEffect, useState } from 'react';
import useILSListSizeEstimate from 'automation-ui-enrollment/hooks/useILSListSizeEstimate';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LONG_LOADING_THRESHOLD_MS = 5000;
const EnrollmentListSizeEstimateAlert = ({
  objectTypeId,
  filterBranch,
  previewLink
}) => {
  const [showLongLoadingMessage, setShowLongLoadingMessage] = useState(false);
  const {
    loading,
    estimate,
    error,
    onCancel
  } = useILSListSizeEstimate(filterBranch, objectTypeId);
  useEffect(() => {
    const timeoutId = setTimeout(() => setShowLongLoadingMessage(true), LONG_LOADING_THRESHOLD_MS);
    return () => {
      clearTimeout(timeoutId);
      onCancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(UIAlert, {
    type: error ? 'danger' : 'warning',
    children: [error ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.hybridCalculation.calculationFailed.estimate_cob",
      objectTypeId: objectTypeId
    }) : loading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      use: "success",
      "data-test-id": "contact-enroll-existing-count-loading",
      showLabel: true,
      label: showLongLoadingMessage ? /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        objectTypeId: objectTypeId,
        baseLangKey: "automation-ui-enrollment.hybridCalculation.loadingCalculationLong_cob"
      }) : /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        objectTypeId: objectTypeId,
        baseLangKey: "automation-ui-enrollment.hybridCalculation.loadingCalculation_cob"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        objectTypeId: objectTypeId,
        baseLangKey: "automation-ui-enrollment.hybridCalculation.metCriteria_cob",
        isJsx: true,
        elements: {
          Bold: 'b'
        },
        options: {
          count: estimate || 0
        }
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.hybridCalculation.estimateDisclaimer"
        })
      })]
    }), previewLink]
  });
};
export default EnrollmentListSizeEstimateAlert;